@if (locationKindList) {
  <p-select
    appendTo="body"
    (onChange)="onLocationKindChange($event)"
    [options]="locationKindList"
    [(ngModel)]="locationKind"
    [placeholder]="locationKind || 'Please select'"
    [filter]="true"
    filterBy="label, value"
    [disabled]="disabled()"
  >
  </p-select>
}
